module.exports = __webpack_public_path__ + "static/media/GOSTUDY_HorizontalWhite.a9ec36c3.png";